"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
function FileLink({ size = 20, title = "File Link", fill }) {
    const theme = (0, styled_components_1.useTheme)();
    fill = fill || theme.icon;
    return (react_1.default.createElement(Base_1.Base, { smooth: true, size: size, fill: fill, title: title, viewBox: "0 0 64 64" },
        react_1.default.createElement("path", { d: "M51.1,27.1l-8.7,8.7c-3.9,3.9-10.2,3.9-14.1,0c0,0,0,0,0,0l2.8-2.8c0,0,0,0,0,0c1.1,1.1,2.6,1.8,4.2,1.8\n\t\t\t\ts3.1-0.6,4.2-1.8l8.7-8.7c1.1-1.1,1.8-2.6,1.8-4.2s-0.6-3.1-1.8-4.2C47.1,14.6,45.6,14,44,14s-3.1,0.6-4.2,1.8\n        l-6,6c-1.5-0.5-3.1-0.8-4.7-0.8c-0.1,0-0.1,0-0.2,0l8-8c3.9-3.9,10.2-3.9,14.1,0C55,16.8,55,23.2,51.1,27.1z\n        M13.4,36.5l8.7-8.7c3.9-3.9,10.2-3.9,14.1,0c0,0,0,0,0,0l-2.8,2.8c0,0,0,0,0,0c-1.1-1.1-2.6-1.8-4.2-1.8\n\t\t\t\ts-3.1,0.6-4.2,1.8l-8.7,8.7c-1.1,1.1-1.8,2.6-1.8,4.2s0.6,3.1,1.8,4.2c1.1,1.1,2.6,1.8,4.2,1.8s3.1-0.6,4.2-1.8\n        l6-6c1.5,0.5,3.1,0.8,4.7,0.8c0.1,0,0.1,0,0.2,0l-8,8c-3.9,3.9-10.2,3.9-14.1,0C9.5,46.8,9.5,40.4,13.4,36.5z" })));
}
exports.default = FileLink;
//# sourceMappingURL=index.js.map